import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { LoadCardComponent } from 'src/app/shared/components/load-until/components/load-card/load-card.component';
import { LoadUntilComponent } from 'src/app/shared/components/load-until/components/load-until/load-until.component';
import { LoadUntilDirective } from 'src/app/shared/components/load-until/load-until.directive';

@NgModule({
  declarations: [LoadUntilDirective, LoadUntilComponent, LoadCardComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [LoadUntilDirective],
})
export class TcsLoadUntilModule {}
